var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('highcharts',{attrs:{"options":_vm.chartOptions}}),_c('highcharts',{attrs:{"options":_vm.chartOptions2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }